const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/delivery/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
/**
 * Delivery landing (`/delivery`). The section shell presents the delivery rail as
 * the mobile selection page; this route remains the desktop prompt.
 */
export const Route = createFileRoute('/_authenticated/_app/delivery/')({
  beforeLoad: requireCapabilities(has => has('deliveries.manage')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});